import PropTypes from 'prop-types';
import React from 'react';
import Layout from '../../../components/Layout';
import Loading from '../../../components/Loading';
import Error from '../../../components/Error';
import HotelList from './HotelList';
import SearchHotelForm from './SearchHotelForm';
import SearchHotelListTable from './SearchHotelListTable';
import Griddle, { plugins, RowDefinition, ColumnDefinition } from 'griddle-react';

import {
  Button,
  ButtonToolbar
} from 'react-bootstrap';


class BrowseHotel extends React.Component {
  constructor(props) {
    super(props);
    this.handleChangeView = this.handleChangeView.bind(this);
    this.state = {
     cardView: true
    };
  }
  componentWillMount() {
    if (this.props.brands.length === 0) {
    this.props.requestBrandOptions();
    this.props.requestBrandGroups();
   }
  }
  componentWillReceiveProps(nextProps) {}

  handleChangeView(){
   this.setState({
    cardView: !this.state.cardView
   })
  }

  render() {

    if (this.props.hasError) {
      return (
        <Layout>
          <Error />
        </Layout>
      );
    }
    if (this.props.needFetch) {
      return (
        <Layout>
          <Loading />
        </Layout>
      );
    }
    if (this.props.id) {
      return (
        <Layout>
          <div>{this.props.children}</div>
        </Layout>
      );
    }
    return (
      <Layout>
        <div className="content-tours">
          <div className="container-fluid">
            <div className="row tour-head">
              <div className="col-md-12 tour-headText">
                <h2>Search Hotels</h2>
              </div>
            </div>
            <hr />
            <div className="row">
              <div className="col-md-12">
                <SearchHotelForm requestHotelSearch={this.props.requestHotelSearch} brands={this.props.brands} brandGroups={this.props.brandGroups} isFetching={this.props.isFetching} isAddHotelSearch={false}/>
                {
                  this.props.hotels.length > 0 && (this.state.cardView ? 
                  (<ButtonToolbar style={{ float: 'right' }}>
                    <Button bsStyle="default" onClick={this.handleChangeView}>
                      <i className="fa fa-bars"></i>
                    </Button>
                  </ButtonToolbar>) 
                  : 
                  (<ButtonToolbar style={{ float: 'right' }}>
                    <Button bsStyle="default" onClick={this.handleChangeView}>
                      <i className="fa fa-th-large"></i>
                    </Button>
                  </ButtonToolbar>))
                }
              </div>
              <div className="col-md-12">
                <p>
                  Browse hotels. <span />
                </p>
              </div>
            </div>
            {this.props.isFetching && <Loading />}
            {(!this.props.isFetching && this.state.cardView) ? (
              <HotelList
                hotels={this.props.hotels}
                requestHotelClaim={() => {}}
                viewHotel={this.props.viewBrowseHotel}
                isSearchHotel={true}
                readOnly
                managed
              />
            ) : (
             <SearchHotelListTable
                hotels={this.props.hotels}
                requestHotelClaim={() => {}}
                viewHotel={this.props.viewBrowseHotel}
                readOnly
                managed
              />)}
          </div>
        </div>
      </Layout>
    );
  }
}

BrowseHotel.propTypes = {
  id: PropTypes.string.isRequired,
  needFetch: PropTypes.bool.isRequired,
  isFetching: PropTypes.bool.isRequired,
  hasError: PropTypes.bool.isRequired,
  children: PropTypes.node,
  hotels: PropTypes.arrayOf(PropTypes.object),
  requestHotelSearch: PropTypes.func.isRequired,
  viewBrowseHotel: PropTypes.func.isRequired,
};
BrowseHotel.defaultProps = {
  hotels: null,
  children: null,
  brands: []
};

export default BrowseHotel;



// WEBPACK FOOTER //
// src/routes/hotels/components/BrowseHotels.js